export default "__VITE_ASSET__CmGE0WCZ__"